export enum ErrorMessages {
    FULL_NAME_REQUIRED = 'Full Name is required',
    MOBILE_NUMBER_REQUIRED = 'Mobile Number is required',
    ENTER_VALID_MOBILE_NUMBER = 'Please enter a valid mobile number (10 digits)',
    MESSAGE_REQUIRED = 'Message is required',
    EMAIL_REQUIRED = 'Email is required',
    ENTER_VALID_EMAIL = 'Please enter a valid email address',
}
